import { TooltipProps } from "@/types/component"

import "./index.scss"

import React, { useState, useRef, useEffect } from "react"
import { createPortal } from "react-dom"

const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  isFirstColumn = false,
  isTableCell = false,
  position = "left",
  variant = "default",
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [tooltipStyle, setTooltipStyle] = useState<React.CSSProperties>({})
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    if (isHovered && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      const customStyle: React.CSSProperties = {}

      if (position === "top") {
        // For table cells (first column), use offset positioning
        if (isFirstColumn) {
          customStyle.left = `${rect.left + rect.width * 0.9}px`
          customStyle.bottom = `${window.innerHeight - rect.top + 8}px`
          customStyle.transform = "translate(-50%, 0)"
        } else {
          // For other elements (like icons), center above the element
          customStyle.left = `${rect.left + rect.width / 2}px`
          customStyle.bottom = `${window.innerHeight - rect.top + 8}px`
          customStyle.transform = "translate(-50%, 0)"
        }
      } else if (position === "bottom") {
        customStyle.left = `${rect.left + rect.width / 2}px`
        customStyle.top = `${rect.bottom + 8}px`
        customStyle.transform = "translate(-50%, 0)"
      } else if (position === "left") {
        customStyle.right = `${window.innerWidth - rect.left + 8}px`
        customStyle.top = `${rect.top + rect.height / 2}px`
        customStyle.transform = "translateY(-50%)"
      } else if (position === "right") {
        customStyle.left = `${rect.right + 8}px`
        customStyle.top = `${rect.top + rect.height / 2}px`
        customStyle.transform = "translateY(-50%)"
      }

      setTooltipStyle(customStyle)
    }
  }, [isHovered, position, isFirstColumn])

  return (
    <>
      <div 
        className={`tooltip-container ${isTableCell ? 'tooltip-container--table-cell' : ''}`}
        ref={containerRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children}
      </div>
      {content && isHovered && createPortal(
        <div
          className={`tooltip ${position} ${variant}`}
          style={{
            ...tooltipStyle,
            position: "fixed",
            zIndex: 10000,
          }}
        >
          {content}
        </div>,
        document.body
      )}
    </>
  )
}

export default Tooltip
